export default __webpack_public_path__ + "static/media/deleteAssessment.30847c28.svg";